import { Box } from '@mui/material'
import { MRT_ColumnDef as MRTColumnDef, MRT_RowData as MRTRowData, MaterialReactTable, MaterialReactTableProps } from 'material-react-table'
import { MessageDescriptor, useIntl } from 'react-intl'
import { TableTitleTypography } from '../Typographies/TableTitleTypography'
import { AddItemAction } from './AddItemAction'
import { DeleteItemAction } from './DeleteItemAction'

type IDataGridProps<TData extends MRTRowData> = MaterialReactTableProps<TData> & {
  contianerStyles?: React.CSSProperties
  heading?: MessageDescriptor
  headingComponent?: React.ReactElement
  handleAddItem?: () => void
  handleBulkDelete?: () => void
  selectedRowCount?: number
  isAddItemDisabled?: boolean
  columns: MRTColumnDef<TData, any>[];

}

// eslint-disable-next-line
export const MRTDataGrid = <TData extends Record<string, any> = {}>(
  props: IDataGridProps<TData>
) => {
  const { formatMessage } = useIntl()

  const styles = {
    boxStyles: {
      borderRadius: '3px',
      padding: '0 10px 10px 10px',
      marginBottom: '20px',
    },
  }

  const {
    heading,
    contianerStyles,
    headingComponent,
    handleAddItem,
    handleBulkDelete,
    enableRowSelection,
    isAddItemDisabled,
    enableDensityToggle = true,
    state,
    ...rest
  } = props

  const rowSelection = state?.rowSelection || {}
  const selectedRowCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length
  return (
    <Box sx={styles.boxStyles}>
      <Box sx={{ display: 'flex', alignContent: 'center', alignItems: 'center', pb: '36px' }}>
          <TableTitleTypography>
            {heading && formatMessage(heading)}
          </TableTitleTypography>
        <AddItemAction
          show={handleAddItem !== undefined}
          onAddItem={handleAddItem}
          isDisabled={isAddItemDisabled}
        />
        <DeleteItemAction
          show={!!enableRowSelection && handleBulkDelete !== undefined}
          onDeleteItem={handleBulkDelete}
          disabled={selectedRowCount === 0}
        />
        {headingComponent}
      </Box>
      <Box style={contianerStyles} sx={{ flexGrow: 1 }}>
        <MaterialReactTable
          initialState={{ density: 'compact' }}
          {...{
            ...rest,
            enableRowSelection,
            enableDensityToggle,
            state: { ...state },
          }}
        />
      </Box>
    </Box>
  )
}

export default MRTDataGrid
